module.exports = __webpack_public_path__ + "static/media/20190402_071229.177a58fe.jpg";